import { http } from "api/http";

const getTallyBillingEntities = () => {
  return http.get("/tally-sync/billing-entities");
};

const getTallySyncableInvoices = ({ queryKey }: any) => {
  const [, billingEntityId] = queryKey;
  return http.get(`/tally-sync/billing-entities/${billingEntityId}/invoices`);
};

const saveTallyCompanyMapping = (data: { billingEntityId: number; tallyCompanyName: string }) => {
  return http.post("/tally-sync/company-mapping", data);
};

export { getTallyBillingEntities, getTallySyncableInvoices, saveTallyCompanyMapping };
